<template>
	<div id="staremail" style="margin-top:-20px;">

		<div class="g-right-middle width800 ">
			<div class="wdfb-list" v-for='(item,key) in list' :key='item.id'>
				<p>
					<router-link :to="'/baikecontent/'+item.praise_actor.id">
						<div class="float-left">
							<i class="email-icon"></i>
							<span style="padding-left: 20px;">{{item.praise_actor.name}}--报名角色：{{item.praise_crew.movie_name}}中的{{item.praise_role.role_name}}</span>
						</div>
					</router-link>
					<div class="float-right" style="width: 140px;">
						<span style="width:100px">{{item.create_time}}</span>

						<span @click="del_list(key,item.id)" class="el-icon-delete icon-del icon-del-right float-right"></span>

					</div>
					<div class="clearfix"></div>

				</p>
			</div>

		</div>
	</div>
	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default {
		data() {
			return {
				list: []
			}
		},
		methods: {
			receive() {
				var api = 'https://api.yopoo.cn/api/centre/getpraise?page=1&count=10&state=2'
				let token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {

					this.list = res.data
				}).catch()

			},
			del_list(key, id) {
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'https://api.yopoo.cn/api/centre/delepraise?state=2&id=' + id
						let token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
								if (res.data.code == 200) {
									this.$message({
										message: res.data.msg,
										type: 'success',
										center: true
									});
									this.list.splice(key, 1) //实际删除内容的索引，删除后页面会刷新删除后的内容，但是实际上没有执行对后台的删除动作
									this.list.splice(id, 1) //实际删除内容的后台id,但删除的内容是key,而且页面不会刷新显示删除的内容
								}
								if (res.data.code == 202) {
									this.$message({
										message: res.data.msg,
										type: 'error',
										center: true
									});
								}
							},
							(err) => {
								console.log(err)
							})
					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				})


			}
		},
		mounted() {
			this.receive()
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/received/G_StarEmail.vue